<template>
    <div>
        <b-container class="mt-5">
            <b-row>
                <b-col>
                    <h1>
                        Your invites
                    </h1>
                </b-col>
            </b-row>
            
            <b-row class="mt-3">
                <b-col class="col-12 col-md-4" v-for="(invite, index) in invites" :key="index">
                    <img v-bind:src="invite.event.small_image">

                    <ul class="list-unstyled">
                        <li class="h3">
                            {{ invite.event.name }}
                        </li>

                        <li>
                            {{ invite.event.start_time }}
                        </li>

                        <li>
                            {{ invite.event.address.full }}
                        </li>
                    </ul>

                    <b-link class="btn btn-info" :to="{ name: 'view-invite', params: { id: invite.id } }">
                        See this invite
                    </b-link>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
    export default {
        computed: {
            invites() {
                return this.$store.getters.invitesByUserId(this.$store.user).map((invite) => {
                    invite.event = this.$store.getters.event(invite.event_id);
                    
                    return invite;
                });
            }
        }
    }
</script>

<style scoped>

</style>